import './style.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import localStorage from '../../../../utils/localStorage';
import StyledTable from "../../../../commons/styles/table";
import { Upload, message, Select, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { API_DOWNLOAD, IPAddress, MAXIMOASSET } from '../../../../commons/api';
import { StyledHomepage } from '../../../../commons/styles/layout';

const { Option } = Select;
const AssetMapping = () => {
  const [fileName, setFileName] = useState('');
  const [DataSource, setDataSource] = useState([]);
  const [type, setType] = useState('Device');

  useEffect(() => {
    getFile();
    getAssetMappingList();
  }, [type]);

  const getFile = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const headers = {
      method: 'GET',
      url: `${MAXIMOASSET.Download}?SiteId=${siteId}&Type=${type}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then((response) => {
        setFileName(response.data.file);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAssetMappingList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const headers = {
      method: 'GET',
      url: `${MAXIMOASSET.List}?SiteId=${siteId}&Type=${type}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then((response) => {
        setDataSource(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isCSV =
      file.type === 'text/csv' ||
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel';
    if (!isCSV) {
      message.error('You can only upload CSV file!');
    }
    if (!isLt2M) {
      message.error('CSV file must be smaller than 10MB!');
    }
    return isLt2M && isCSV;
  };

  const handleChange = (info) => {
    const { status } = info.file;
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const AssetColumn = [
    {
      title: 'Id',
      dataIndex: 'Id',
      key: 'Id'
    },
    {
      title: 'Device',
      dataIndex: 'Device',
      key: 'Device'
    },
    {
      title: 'Asset',
      dataIndex: 'Asset',
      key: 'Asset'
    }
  ];

  const token = localStorage.get('accessToken');
  const Authorization = 'Bearer ' + token;
  const siteId = localStorage.get('currentSite');

  return (
    <StyledHomepage>
      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "10px" }}>
          {fileName ? (
            <a href={`${IPAddress.LOCAL}${API_DOWNLOAD.DownloadAMS}/${fileName}`}>
              <Button type='primary'>
                <DownOutlined /> {fileName}
              </Button>
            </a>
          ) : (
            <Button type='primary'>No file to download</Button>
          )}
        </div>
        <Upload
          name="file"
          accept=".csv"
          action={`${MAXIMOASSET.Upload}?SiteId=${siteId}&Type=${type}`}
          headers={{ Authorization }}
          multiple={false}
          beforeUpload={beforeUpload}
          onChange={handleChange}
        >
          <Button type="primary">Upload CSV File</Button>
        </Upload>

        <Select style={{ marginLeft: 8 }} value={type} onChange={(value) => setType(value)}>
          <Option value="Asset">Asset</Option>
          <Option value="Device">Device</Option>
        </Select>
      </div>
      <div style={{ marginTop: '20px' }}>
        <StyledTable
          size="small"
          columns={AssetColumn}
          pagination={
            DataSource.length > 10
              ? { pageSize: 10 }
              : false
          }
          dataSource={DataSource.map((data, index) => ({ ...data, key: index }))}
        />
      </div>
    </StyledHomepage>
  );
};

export default AssetMapping;
